module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPHBhdGggZD0iTTAgMGg1MTJ2MTcwLjY2N0gweiIgZmlsbD0icmVkIi8+CiAgPHBhdGggZD0iTTAgMTcwLjY2N2g1MTJ2MTcwLjY2NkgweiIgZmlsbD0iIzAwZiIvPgogIDxwYXRoIGQ9Ik0wIDM0MS4zMzNoNTEyVjUxMkgweiIgZmlsbD0ib3JhbmdlIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/am.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/am.svg
// module chunks = 0